
<div class="not-found">
    <h1>404</h1>
    <p>Sorry, the page you are looking for does not exist.</p>
    <a routerLink="/">Go to Home</a>
  </div>